import React, { useEffect, useState } from 'react';

import { ResultTableUnified} from './Components/ResultTableUnified';
import { ResultTableTabs }   from './Components/ResultTableTabs';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { useApolloClient } from "@apollo/client";
import { connect } from "react-redux";
import { addToDownloadRequest, removeFromDownloadRequest } from "../../../actions/downloadManager";
import DownloadRequestButton from "../Icons/DownloadManager/DownloadRequestButton";
import { Title, WrapperDiv } from "./Components/ResultTableStyled/ResultTableStyled";

/*
 *  @Description:   Component that renders a table in order to show data.
 */

const ResultTable = ( props ) => {
    const {
        type,
        data,
        fieldsToShow,
        title,
        centered,
        defaultAction,
        showPointer,
        withoutShadows,
        tableUnified,
    } = props;
    const userRoles = (localStorage.getItem('roles') != null ) ? localStorage.getItem('roles').split(',') : [];
    const userSalesOrgs = (localStorage.getItem('salesOrgs') != null ) ? localStorage.getItem('salesOrgs').split(',') : [];

    const client = useApolloClient ();
    const [createdSortOrder, setCreatedSortOrder] = useState("asc");
    const [updatedSortOrder, setUpdatedSortOrder] = useState("asc");
    const [dataToSort, setSortData] = useState(data)
    //VIEW CONDITIONS
    const displayAsSections = tableUnified === false  && data && data.length > 0;
    const displayAsTable = tableUnified === true && data && data.length > 0;
    const noDataToShow = data && data.length === 0;

    const setSelectedForDownload = ( row ) => {
        if ( props.downloadRequest.includes ( row.uuid ) ) {
            props.removeFromDownloadRequest ( row.uuid );
        } else {
            props.addToDownloadRequest ( row.uuid );
        }
        // TODO: Add some analytics into the mix...
    }
    const sortData = (e,fieldToShow) => {
        e.preventDefault()
        let sortedData;
        if ( fieldToShow=== 'updated') {
            sortedData = [...dataToSort].sort((a, b) => {

                return updatedSortOrder === "asc"
                    ? new Date(a.metadata.entityChanged) - new Date(b.metadata.entityChanged)
                    : new Date(b.metadata.entityChanged) - new Date(a.metadata.entityChanged);
            });
            setUpdatedSortOrder(updatedSortOrder === "asc" ? "desc" : "asc");
            setSortData(sortedData);
        }
        if (fieldToShow === 'created') {
             sortedData = [...dataToSort].sort((a, b) => {

                return createdSortOrder === "asc"
                    ? new Date(a.metadata.entityCreated) - new Date(b.metadata.entityCreated)
                    : new Date(b.metadata.entityCreated) - new Date(a.metadata.entityCreated);
            });
            setCreatedSortOrder(createdSortOrder === "asc" ? "desc" : "asc");
            setSortData(sortedData);

        }
    };

    const sendPlaylistDownloadRequest = ( id ) => {
        console.log ( "Playlist download Request", { requestForDownload: id } )
    }
    useEffect(() => {
        setSortData(data)
    }, [data])

    return (
        <WrapperDiv className={ type } centered={ centered } withoutShadows={ withoutShadows }>
            { tableUnified === false && <div style={ { display: "flex", flexDirection: "row", justifyContent: "space-between" } }>
                <Title>
                    { title }
                </Title>
                {
                    title.toLowerCase ().includes ( "resources" ) &&
                    <DownloadRequestButton
                        requestLength={ props.downloadRequest.length }
                        onClick={ () => console.log ( { "Resources downloadRequest": props.downloadRequest } ) }
                    />
                }
            </div>}

            {displayAsSections && <ResultTableTabs
                fieldsToShow={fieldsToShow}
                data={data}
                type={type}
                tableUnified={tableUnified}
                userRoles={userRoles}
                userSalesOrgs={userSalesOrgs? userSalesOrgs: props.settings.salesOrganizations}
                defaultAction={defaultAction}
                showPointer={showPointer}
                client={client}
                setSelectedForDownload={setSelectedForDownload}
                sendPlaylistDownloadRequest={sendPlaylistDownloadRequest}
                downloadRequest={props.downloadRequest}
            /> }
            { displayAsTable  && <ResultTableUnified
                fieldsToShow={ fieldsToShow }
                data = { data }
                dataToSort={ dataToSort }
                type={ type }
                tableUnified={ tableUnified }
                userRoles={ userRoles }
                userSalesOrgs={userSalesOrgs? userSalesOrgs: props.settings.salesOrganizations}
                defaultAction={ defaultAction }
                showPointer={ showPointer }
                client={ client }
                setSelectedForDownload={ setSelectedForDownload }
                sendPlaylistDownloadRequest={ sendPlaylistDownloadRequest }
                sortData={sortData}
                updatedSortOrder={updatedSortOrder}
                createdSortOrder={createdSortOrder}
                downloadRequest={ props.downloadRequest }
            />}
            { noDataToShow && <p>No data to show</p> }
        </WrapperDiv>
    );
}

const mapStateToProps = ( state ) => ( {
    downloadRequest: state.downloadManager.downloadRequest,
    settings: state.settings
} )

export default connect ( mapStateToProps, {
    addToDownloadRequest,
    removeFromDownloadRequest
} ) ( ResultTable );
